/* eslint-disable camelcase */
/**
 * @author Daniel Aguirre
 * @file index.js
 * @description ClinicPhones Services
 */

// Core
import endpoints from '@nephro/config/endpoints';
import { externalConnector } from '@nephro/core/connector';

// Endpoints
const { clinicPhones: clinicPhonesEndPoints } = endpoints;

export class ClinicPhonesService {
  constructor(http) {
    this.http = http;
  }

  /**
   * Create ClinicPhones
   * @param { Object } clinic - clinic data.
   * @param { Object } phone - phone data.
   * @return { promise } - The ClinicPhones promise object.
   */
  createClinicPhones = async (clinic, phone) => {
    const body = { clinic, phone };
    const url = clinicPhonesEndPoints.base;
    return this.http.post(url, body);
  };

  /**
   * Get ClinicPhones list with pagination
   * @param { string } paged - Activate pagination.
   * @param { string } limit - Items per page.
   * @param { string } page - Current page.
   * @return { Object } - Get ClinicPhones list.
   */
  getClinicPhones = async (paged, limit, page) => {
    const queryParam = `?limit=${limit}&page=${page}&paged=${paged}`;
    let url = clinicPhonesEndPoints.base;
    if (paged) {
      url = `${url}${queryParam}`;
    }
    return this.http.get(url);
  };

  /**
   * Get ClinicPhones info by id
   * @param { string } id - ClinicPhones id.
   * @return { Object } - Get ClinicPhones list.
   */
  getClinicPhonesById = async (id) => {
    const url = `${clinicPhonesEndPoints.base}/${id}`;
    return this.http.get(url);
  };

  /**
   * Delete ClinicPhones by id
   * @param { string } id - ClinicPhones id.
   * @return { Object } - Get ClinicPhones list.
   */
  deleteClinicPhonesById = async (id) => {
    const url = `${clinicPhonesEndPoints.base}/${id}`;
    return this.http.delete(url);
  };

  /**
   * Update ClinicPhones
   * @param { Object } clinic - clinic data.
   * @param { Object } phone - phone data.
   * @param { string } id - ClinicPhones id.
   * @return { promise } - The ClinicPhones promise object.
   */
  updateClinicPhones = async (clinic, phone, id) => {
    const body = { clinic, phone };
    const url = `${clinicPhonesEndPoints.base}/${id}`;
    return this.http.update(url, body, {}, 'put');
  };

  /**
   * Get clinic phones by clinic name
   * @param { string } clinicName - Clinic name.
   * @return { Object } - Get parameters list.
   */
  getClinicPhonesByClinicName = async (clinicName) => {
    const queryParam = `?clinicName=${clinicName}`;
    const url = clinicPhonesEndPoints.clinicByName;
    return this.http.get(`${url}${queryParam}`);
  };
}

export default new ClinicPhonesService(externalConnector);
